import { KeyboardAwareScrollView } from 'react-native-keyboard-controller'
import { withUnistyles } from 'react-native-unistyles'

const UniKeyboardAwareScrollView = withUnistyles(KeyboardAwareScrollView)

export default UniKeyboardAwareScrollView
